const nextConfig = {
    eslint: {
        ignoreDuringBuilds: true,
    },
    typescript: {
        ignoreBuildErrors: true,
    },
    images: {
        remotePatterns: [
            { protocol: "https", hostname: "tse2.mm.bing.net" },
            { protocol: "https", hostname: "via.placeholder.com" },
            { protocol: "https", hostname: "sanpham.starglobal3d.com" },
            { protocol: "https", hostname: "sanpham.starglobal3d.vn" },
            { protocol: "https", hostname: "upload.wikimedia.org" },
            { protocol: "https", hostname: "platform.starglobal3d.com" },
            { protocol: "https", hostname: "s3.hcm-1.cloud.cmctelecom.vn" },
        ],
        minimumCacheTTL: 3600,
        formats: ["image/avif", "image/webp"],
        // unoptimized: true, // Cần thiết cho static export

        domains: ['cellphones.com.vn', 'minhducpc.vn', 'krpano.com', 'images.unsplash.com', 's3.hcm-1.cloud.cmctelecom.vn', 'cdn2.fptshop.com.vn'], // Thêm các domain bạn muốn load ảnh từ đây
    },
    output: "standalone", // Enable standalone mode for Docker
    poweredByHeader: false,
    // pdfjs-dist (react-pdf) references browser-only globals (DOMMatrix, Path2D...) at module
    // load time. Even with next/dynamic({ ssr: false }), webpack still bundles it into the
    // server chunk graph, which crashes with "ReferenceError: DOMMatrix is not defined" on
    // every [sector]/[project] page since the Heritage template graph is imported eagerly.
    // Marking it external keeps it out of the server bundle entirely.
    // playcanvas references `node:worker_threads`; when Turbopack bundles it for SSR it emits an
    // "[externals]_node:worker_threads" chunk whose ':' is an invalid filename on Windows (os error 123).
    serverExternalPackages: ["pdfjs-dist", "react-pdf", "playcanvas"],
    async headers() {
        const csp = [
            "default-src 'self'",
            "script-src 'self' 'unsafe-inline' 'unsafe-eval' https://maps.googleapis.com https://apis.google.com https://*.googleapis.com https://*.gstatic.com https://generativelanguage.googleapis.com",
            "style-src 'self' 'unsafe-inline' https://*.googleapis.com",
            "img-src 'self' data: blob: https://s3.hcm-1.cloud.cmctelecom.vn https://*.googleapis.com https://*.gstatic.com",
            "font-src 'self' data: https://*.gstatic.com",
            "connect-src 'self' https://api.starglobal3d.com wss://api.starglobal3d.com https://s3.hcm-1.cloud.cmctelecom.vn https://maps.googleapis.com https://apis.google.com https://*.googleapis.com https://*.gstatic.com https://generativelanguage.googleapis.com",
            "media-src 'self' blob: https://s3.hcm-1.cloud.cmctelecom.vn",
        ].join('; ');

        // Chỉ các domain sau được phép nhúng site này vào iframe.
        // frame-ancestors không nhận path (vd "/*"), chỉ nhận scheme+host(+port).
        const frameAncestorsCsp = [
            "frame-ancestors 'self' https://starglobal3d.com https://*.starglobal3d.com https://dulichhatinh360.com https://thegioidisan.vn https://www.thegioidisan.vn https://stg.thegioidisan.vn https://*.thegioidisan.vn https://visitvietnam360.com https://*.visitvietnam360.com https://eduverse3d.com https://*.eduverse3d.com https://eduverse3d.vn https://*.eduverse3d.vn https://touriverse3d.com https://*.touriverse3d.com https://a1tech.vn",
        ].join('; ');

        return [
            {
                source: '/:path*',
                headers: [
                    { key: 'Content-Security-Policy-Report-Only', value: csp },
                    // Header CSP riêng, enforced (không phải report-only) để chặn nhúng
                    // iframe ngoài whitelist. frame-ancestors bị report-only header
                    // ở trên bỏ qua nên phải tách ra header enforced độc lập.
                    { key: 'Content-Security-Policy', value: frameAncestorsCsp },
                    { key: 'X-Content-Type-Options', value: 'nosniff' },
                    { key: 'Referrer-Policy', value: 'strict-origin-when-cross-origin' },
                    { key: 'Permissions-Policy', value: 'camera=(self), microphone=(self), geolocation=(self)' },
                ],
            },
        ];
    },
    env: {
        // NEXTAUTH_SECRET intentionally omitted: NextAuth reads it directly from
        // process.env server-side; listing it here would inline it into client bundles.
        API_LANGUAGE: process.env.API_LANGUAGE,
        NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
        NEXT_PUBLIC_API_URI: process.env.NEXT_PUBLIC_API_URI,
    },
    // output: "export", // Kích hoạt Static HTML Export
    basePath: process.env.NEXT_PUBLIC_BASE_PATH_STATIC ? process.env.NEXT_PUBLIC_BASE_PATH_STATIC : "", // Đường dẫn gốc cho ứng dụng
    assetPrefix: process.env.NEXT_PUBLIC_BASE_PATH_STATIC ? process.env.NEXT_PUBLIC_BASE_PATH_STATIC : "", // Prefix cho tài nguyên tĩnh
    trailingSlash: true, // Thêm dấu / vào cuối URL
    // distDir: 'out', // Thư mục output
    webpack: (config, { dev, isServer }) => {
        // Disable source maps in development
        if (dev) {
            config.devtool = false;
        }
        return config;
    },
    productionBrowserSourceMaps: false,
};

export default nextConfig;
